import React, { useState, useEffect } from "react";
import { Space, Col, Row } from "antd";
import BusinessModal from "../business_pages/components/BusinessForm";
import SuccessModal from "../business_pages/components/SuccessModal";

const ContactSection = () => {
  const [isFormModalVisible, setIsFormModalVisible] = useState(false);
  const [isSuccessModalVisible, setIsSuccessModalVisible] = useState(false);

  return (
    <>
      <div style={{ marginBottom: -100 }}>
        <Row align="middle">
          <Col span={24} md={{ span: 12 }} xl={{ span: 8, offset: 4 }}>
            <img
              style={{ width: "100%" }}
              src="/imgs/business_page/envelope-party.svg"
            />
          </Col>
          <Col span={24} md={{ span: 12 }} xl={{ span: 9 }}>
            <div style={{ padding: 20 }}>
              <div className="header-title-3" style={{ marginBottom: 20 }}>
                {"Reikia verslui pritaikytų sprendimų?"}
              </div>
              <button
                className="btn btn-primary-alsendo btn-lg btn-circle"
                onClick={() => {
                  setIsFormModalVisible(true);
                }}
              >
                {"Gauti pasiūlymą"}
              </button>

              <Row gutter={[32, 32]} style={{ marginTop: '25px' }}>
                <Col span={24} lg={{ span: 12 }}>
                  <Space>
                    <img src="/imgs/business_page/envelope.svg" />
                    <div className="info-font nice-select">
                      <a href="mailto: pardavimai@siusk24.lt">
                        {"pardavimai@siusk24.lt"}
                      </a>
                    </div>
                  </Space>
                </Col>
                <Col span={24} lg={{ span: 12 }}>
                  <Space>
                    <img src="/imgs/business_page/phone.svg" />
                    <div className="info-font nice-select">
                      <a href="tel: +37065828980">{"+370 658 28980"}</a>
                    </div>
                  </Space>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        {isFormModalVisible && (
          <BusinessModal
            setIsFormModalVisible={setIsFormModalVisible}
            setIsSuccessModalVisible={setIsSuccessModalVisible}
          />
        )}
        {isSuccessModalVisible && (
          <SuccessModal setIsSuccessModalVisible={setIsSuccessModalVisible} />
        )}
      </div>
    </>
  );
};

export default ContactSection;
